import {
	apis
} from '@/utils/api.js';
export const configStore = defineStore('config', {
	state: () => ({
		configData: {
			IDcodeShow: '1',
			codetext: '0',
			repayment: '1',
			withdrawal: '1',
			personalInfo: '1',//个人信息页--是否显示月收入字段
			educationInfo: '1',//个人信息页--是否显示教育学平字段
			emailinfo: '1',//个人信息页--是否显示邮箱字段
			locationinfo: '1'//个人信息页--是否显示地址字段
		},
		userOpenDialog: false,
		update: false,
		uniPlatform: uni.getSystemInfoSync().uniPlatform,
		osName: uni.getSystemInfoSync().osName
	}),
	actions: {
		initConfigData() {
			return new Promise((resolve, reject) => {
				if (uni.getStorageSync('configData')) this.configData = uni.getStorageSync('configData')
				apis.home.cfgIndex().then(res => {
					let [err, cData] = res
					if (err) {
						resolve(true)
					}
					let {
						data,
						msg
					} = cData;
					this.configData = cData.data
					if(this.uniPlatform != 'web'){
						let currentVersion = plus.runtime.versionCode
						let ver = ''
						if(this.osName == 'ios'){
							ver = this.configData.verIos.replace(/\./g, '')
						}else{
							ver = this.configData.ver.replace(/\./g, '')
						}
						if (ver > parseInt(currentVersion)) {
							this.update = true
						}else{
							this.update = false
						}
					}
					uni.setStorageSync('configData', this.configData)
					resolve(true)
				})
			})
		}

	},
});
